import { MenuItemType } from "../pages/components/ResponsiveMenu";

export const menuItems: MenuItemType[] = [
  {
    label: "Productos",
    subItems: [
      { label: "Administracion", path: "productos/admin", requiredPermission: "administrar_productos" },
      { label: "Modificacion de Precios", path: "productos/modificacion-precios", requiredPermission: "actualizar_precios" },
      { label: "Produccion", path: "productos/produccion", requiredPermission: "produccion" },
      { label: "Lista de Precios", path: "listaprecios", requiredPermission: "lista_precios" },
    ],
  },
  {
    label: "Reportes",
    subItems: [
      { label: "Ventas", path: "reportes/ventas", requiredPermission: "reporte_ventas" },
      { label: "Cajas", path: "reportes/cajas", requiredPermission: "reporte_cajas" },
      { label: "Stock por Local", path: "reportes/stock-local", requiredPermission: "reporte_stock" },
      { label: "Estados Clientes", path: "reportes/estadoscuentasclientes", requiredPermission: "reporte_estados_clientes" },
    ],
  },
  {
    label: "Proveedores",
    subItems: [
      { label: "Compras", path: "compras/carga", requiredPermission: "compras" },
      { label: "Reporte de Compras", path: "compras/reporte", requiredPermission: "compras" },
    ],
  },
  {
    label: "Clientes",
    subItems: [
      { label: "Portal", path: "clientes/portal", requiredPermission: "pedidos_clientes" },
      { label: "Carrito", path: "pedidos/carrito", requiredPermission: "pedidos_clientes" },
    ],
  },
  {
    label: "Ventas y Pedidos",
    subItems: [
      { label: "Punto de Venta", path: "puntoventa", requiredPermission: "orden_venta" },
      { label: "Orden de Venta", path: "ordenventa", requiredPermission: "orden_venta" },
      { label: "Pedido Web", path: "pedidoweb", requiredPermission: "pedidos_clientes" },
      { label: "Presupuesto", path: "presupuesto", requiredPermission: "presupuesto" },
      { label: "Comanda Mesa", path: "comandamesa", requiredPermission: "comanda_mesa" },
    ],
  },
  { label: "Autorizar Operacion", path: "autorizaroperacion", requiredPermission: "autorizar_operacion" },
];
